import GraphQLClient from './clients/GraphQLClient'

export default {
  getBlogs (payload) {
    return GraphQLClient.post('/', payload)
  }
}
